import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { handleFormatMoney } from './InputFormatMoney';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = (theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  textFieldSize: {
    width: 250,
    marginLeft: '10px',
    marginRight: '15px',
  },
  dense: {
    marginTop: 19,
    color: '#9C9C9C',
  },
  input: {
    outline: 0,
    paddingLeft: 5,
    // marginBottom: 5,
    height: 30,
    border: 'none',
    paddingBottom: 2,
    //borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  separator: {
    padding: '0px 10px',
    color: '#757575',
  },
  sizeFont: {
    fontSize: 14,
  },
  span: {
    width: '100%',
    color: '#757575',
  },
  inputLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: '0',
    fontSize: '1rem',
    fontFamily: 'Roboto, Helvetica, arial, sans-serif',
    fontWeight: '400',
    lineHeight: '1',
    letterSpacing: '0.00938em',
  }
});

class InputRange extends Component {
  state = {
    min: '',
    max: '',
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearAll !== prevProps.clearAll && this.props.clearAll) {
      this.setState({
        min: '',
        max: ''
      }, () => {
        this.props.getInputRange(this.state.min, this.state.max)
      })
    }

    return null
  }

  // handleChange = name => event => {
  //   this.setState({
  //     [name]: event.target.value
  //   }, () =>{
  //     this.props.getInputRange(event.target.value)
  //   })
  // };

  handleChangeMin = event => {
    let minValue = handleFormatMoney(event.target.value)
    this.setState({
      min: minValue
    }, () => {
      this.props.getInputRange(this.state.min, this.state.max)
    })
  }

  handleChangeMax = event => {
    let maxValue = handleFormatMoney(event.target.value)
    this.setState({
      max: maxValue
    }, () => {
      this.props.getInputRange(this.state.min, this.state.max)
    })
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <span className={`${classes.span} ${classes.sizeFont}`}>VALOR</span>
        <div className={classes.flex}>

          <div>
            <span className={`${classes.span} ${classes.sizeFont}`}>De </span>
            <TextField
              value={this.state.min}
              className={classes.input}
              onChange={this.handleChangeMin}
              maxLength={25}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    R$
                  </InputAdornment>
                ),
              }} />
          </div>

          <span className={classes.separator}>a</span>
          <div>
            <TextField
              value={this.state.max}
              className={classes.input}
              onChange={this.handleChangeMax}
              maxLength={25}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    R$
                  </InputAdornment>
                ),
              }} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(InputRange)